import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrentVersions } from './symbols';

@Injectable()
export class CheckVersionService {
  constructor(private http: HttpClient) {
  }

  getVersions(): Observable<CurrentVersions> {
    return this.http.get<CurrentVersions>('/api/check-versions');
  }
}
